<template>
  <div class="pa-5">
    <v-alert
      color="green"
      :icon="alertIcon"
      prominent
      text
      type="success"
    >
      <span v-if="sendImmediately">
        You are about to Send the following text message to {{ recipientName }} at {{ recipientPhoneNumber }}
        for immediate delivery:
      </span>
      <span v-else>
        You are about to save a text message for {{ recipientName }} at {{ recipientPhoneNumber }} to be delivered on
        {{ editedDocketEntry.action_date | formatDate }} @ {{ editedDocketEntry.event_time_start }} with the following
        text:
      </span>
    </v-alert>

    <v-alert
      :icon="false"
      prominent
      type="info"
    >
      {{ editedDocketEntry.comment }}
    </v-alert>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { formattedPhoneNumber, partyName } from '@/utilities'

import { DOCKET_ENTRY_NAMESPACE } from '@/store/docket-entry'
import { LEGAL_CASE_NAMESPACE } from '@/store/legal-case'

export default {
  name: 'TextMessageEditorConfirmation',

  props: {
    sendImmediately: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    alertIcon () {
      return this.sendImmediately ? 'mdi-message-check-outline' : 'mdi-calendar-check'
    },

    legalCase () {
      return this.legalCases.find(lc => lc.id === this.editedDocketEntry.legal_case_id)
    },

    legalCaseParties () {
      return this.legalCase?.parties || []
    },

    recipient () {
      return this.legalCaseParties.find(lcp => lcp.id === this.editedDocketEntry.docket_entry_recipient.party_id)
    },

    recipientName () {
      return partyName(this.recipient)
    },

    recipientPhoneNumber () {
      const preferredText = this.recipient.phones.find(p => p.preferred_text)
      return formattedPhoneNumber(preferredText)
    },

    ...mapGetters(DOCKET_ENTRY_NAMESPACE, [
      'editedDocketEntry',
    ]),

    ...mapGetters(LEGAL_CASE_NAMESPACE, [
      'legalCases',
    ]),
  },
}
</script>
